import { render } from "./about-carousel.vue?vue&type=template&id=078d649c&ts=true"
import script from "./about-carousel.vue?vue&type=script&lang=ts"
export * from "./about-carousel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__